<template>
    <div>
        <b-overlay :show="this.isOverlay" spinner-variant="primary" >
            <CHead :oHead="oHead">
            </CHead>
            <div class="row justify-content-center mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-10">
                    <div class="card card-01">
                        <div  v-if="ShowComponents" class="row mt-2">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-10">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group form-row">
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                                                <label>Cliente</label>
                                                <input placeholder="Cliente" type="text" class="form-control" v-model="Ocliente.NomCliente"  readonly="true">
                                                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Cliente" :Mensaje="errorvalidacion.Cliente[0]"></Cvalidation></label>
                                            </div>

                                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" :disabled="cotizacion_servicio.IdPropuesta!=0" class="btn btn-01 search mx-sm-3 mt-6" @click="ListaCliente" data-toggle="modal" data-target="#ModalForm3"  data-backdrop="static">Buscar</button>
                                            </div>
											<div class="col-12 col-sm-12 col-md-7 col-lg-7">
												<div class="row pt-4">
													<div class="col-lg-3">
														<div class="form-check form-check-inline">
															<label class="check_box m-0 pl-4">
                                								<input :disabled="cotizacion_servicio.IdPropuesta!=0" checked id="0" v-model="cotizacion_servicio.Propuesta" value="0" type="radio" class="form-check-input">
                                								<span class="checkmark" :style="cotizacion_servicio.IdPropuesta!=0 ? 'border:2px solid #bababa;background-color: grey;' : 'border:2px solid #bababa;'"></span>
                            								</label>
															<span class="bold">Sin Propuesta</span>
														</div>
													</div>
													<div class="col-lg-4">
														<div class="form-check form-check-inline">
															<label class="check_box m-0 pl-4">
                                								<input :disabled="cotizacion_servicio.IdPropuesta!=0 || Vendedor.IdVendedor==0" checked id="1" v-model="cotizacion_servicio.Propuesta" value="1" type="radio" class="form-check-input">
                                								<span class="checkmark" :style="cotizacion_servicio.IdPropuesta!=0 || Vendedor.IdVendedor==0 ? 'border:2px solid #bababa;background-color: grey;' : 'border:2px solid #bababa;'"></span>
                            								</label>
															<span class="bold">Generar Propuesta</span>
														</div>
													</div>
													<!-- <div class="col-lg-4" v-show="cotizacion_servicio.Propuesta==1">
														<div class="form-check form-check-inline">
															<label class="check_box m-0 pl-4">
                                								<input :disabled="cotizacion_servicio.IdPropuesta!=0" id="2" v-model="cotizacion_servicio.VerDesglose" value="1" type="checkbox" class="form-check-input">
                                								<span class="checkmark" :style="cotizacion_servicio.IdPropuesta!=0 ? 'border:2px solid #bababa;background-color: grey;' : 'border:2px solid #bababa;'"></span>
                            								</label>
															<span class="bold">Ver Desglose</span>
														</div>
													</div> -->
												</div>
											</div>
                                        </div>
										<div class="form-group row">
											<div class="col-12 col-sm-12 col-md-6 col-lg-3 pr-0">
                                                <label>Propiedad</label>
                                                <input placeholder="Propiedad" type="text" class="form-control" v-model="Ocliente.Nombre"  readonly="true">
                                                <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Cliente" :Mensaje="errorvalidacion.Cliente[0]"></Cvalidation></label>
                                            </div>
											<div class="col-12 col-sm-12 col-md-6 col-lg-2">
                                                <label>Teléfono</label>
                                                <input placeholder="Teléfono"  v-model="Ocliente.Telefono"  type="text" class="form-control" readonly="true">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                                                <label>Correo</label>
                                                <input placeholder="Correo" v-model="Ocliente.Correo"  type="text" class="form-control" readonly="true">
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-8 col-lg-4">
                                                <label>Dirección</label>
                                                <input placeholder="Dirección" v-model="Ocliente.Direccion"  type="text" class="form-control" readonly="true">
                                            </div>
										</div>
                                        <div class="form-group form-row">
											<div v-show="cotizacion_servicio.Propuesta==1" class="col-12 col-sm-12 col-md-6 col-lg-3">
												<label for="">Nombre de la Propuesta</label>
												<input :disabled="cotizacion_servicio.IdPropuesta!=0" type="text" class="form-control" placeholder="Nombre de la Propuesta" v-model="cotizacion_servicio.NombrePropuesta">
											</div>
											<div class="col-12 col-sm-12 col-md-6 col-lg-3">
												<label for="">Id Activo</label>
												<treeselect
												:options="Equipos"
												:disabled="cotizacion_servicio.IdPropuesta!=0"
												placeholder="Busque un Activo..."
												v-model="cotizacion_servicio.IdEquipo"
												:disable-fuzzy-matching="true"
												@search-change="BusquedaEquipo"
											/>
											</div>

                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <nav>
                                            <div class="nav nav-tabs nav-tabs-table" id="nav-tab" role="tablist">
                                                <a @click="CambiarPestania('Datos')" class="nav-item nav-link active" style="width:12%" id="dato-tab" data-toggle="tab" href="#nav-dato" role="tab" aria-controls="nav-dato" aria-selected="true">Datos</a>
                                                <a @click="CambiarPestania('Materiales')" class="nav-item nav-link" style="width:12%" id="material-tab" data-toggle="tab" href="#nav-material" role="tab" aria-controls="nav-material" aria-selected="false">Materiales</a>
												<a @click="CambiarPestania('Refacciones')" class="nav-item nav-link" style="width:12%" id="refaccion-tab" data-toggle="tab" href="#nav-refaccion" role="tab" aria-controls="nav-refaccion" aria-selected="false">Refacciones</a>
                                                <a @click="CambiarPestania('Equipos')" class="nav-item nav-link" style="width:12%" id="equipo-tab" data-toggle="tab" href="#nav-equipo" role="tab" aria-controls="nav-equipo" aria-selected="false">Equipos</a>
												<a @click="CambiarPestania('ManoDeObra')" class="nav-item nav-link" style="width:12%" id="obra-tab" data-toggle="tab" href="#nav-obra" role="tab" aria-controls="nav-obra" aria-selected="false">Mano de Obra</a>
                                                <a @click="CambiarPestania('Contratistas')" class="nav-item nav-link" style="width:12%" id="contratista-tab" data-toggle="tab" href="#nav-contratista" role="tab" aria-controls="nav-contratista" aria-selected="false">Contratistas</a>
                                                <a @click="CambiarPestania('Viaticos')" class="nav-item nav-link" style="width:12%" id="viatico-tab" data-toggle="tab" href="#nav-viatico" role="tab" aria-controls="nav-viatico" aria-selected="false">Viaticos</a>
                                                <!-- <a class="nav-item nav-link" id="miscelaneos-tab" data-toggle="tab" href="#nav-miscelaneos" role="tab" aria-controls="nav-miscelaneos" aria-selected="false">Misceláneos</a> -->
												<button :disabled="cotizacion_servicio.IdPropuesta!=0" v-if="Botones.Materiales" data-toggle="modal" data-target="#ModalForm" type="button" class="btn btn-01 btn-pink ml-auto"><i class="fa fa-plus-circle"></i> Agregar</button>
												<button :disabled="cotizacion_servicio.IdPropuesta!=0" v-if="Botones.Refacciones" data-toggle="modal" data-target="#ModalForm4" type="button" class="btn btn-01 btn-pink ml-auto"><i class="fa fa-plus-circle"></i> Agregar</button>
												<button :disabled="cotizacion_servicio.IdPropuesta!=0" v-if="Botones.Equipos" data-toggle="modal" data-target="#ModalForm2" type="button" class="btn btn-01 btn-pink ml-auto"><i class="fa fa-plus-circle"></i> Agregar</button>
												<button :disabled="cotizacion_servicio.IdPropuesta!=0" v-if="Botones.Contratistas" @click="add_Contratistas(undefined)" type="button" class="btn btn-01 btn-pink ml-auto"><i class="fa fa-plus-circle"></i> Agregar</button>
												<button :disabled="cotizacion_servicio.IdPropuesta!=0" v-if="Botones.Viaticos" @click="add_Viaticos(undefined)" type="button" class="btn btn-01 btn-pink ml-auto"><i class="fa fa-plus-circle"></i> Agregar</button>
											</div>
                                        </nav>
                                        <div class="tab-content tab-content-table">
                                            <div class="tab-pane fade show active" id="nav-dato" role="tabpanel" aria-labelledby="dato-tab">
                                                <div class="row mt-2">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <h4>Datos de Sitio</h4>
                                                        <hr>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-3 col-lg-3" style="max-width:8vw !important">
                                                        <label>Distancia KM</label>
                                                        <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" @input="CalcularCostoKM" placeholder="0 Km"  :minus="false" class="form-control"  currency="" separator="," :precision="1" v-model="cotizacion_servicio.Distancia"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Distancia" :Mensaje="errorvalidacion.Distancia[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" style="max-width:9vw !important">
                                                        <label>Velocidad Prom.</label>
                                                        <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" @input="CalcularTotalMODesplazamiento();CalcularTotalCostoBurden()" placeholder="0 Km/h"  :minus="false" class="form-control"  currency="" separator="," :precision="0" v-model="cotizacion_servicio.Velocidad"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Velocidad" :Mensaje="errorvalidacion.Velocidad[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" style="max-width:9vw !important">
                                                        <label>Costo KM</label>
                                                        <vue-numeric placeholder="$ 0.00"  disabled :minus="false" class="form-control"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.CostoKm"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CostoKm" :Mensaje="errorvalidacion.CostoKm[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                                        <label>Garantía %</label>
                                                        <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" @input="CalcularTotalGarantia" placeholder="0 %"  :minus="false" class="form-control w-03"  currency="" separator="," :precision="0" v-model="cotizacion_servicio.Garantia"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Garantia" :Mensaje="errorvalidacion.Garantia[0]"></Cvalidation></label>
                                                    </div>
                                                </div>
                                                <div class="row mt-1">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <h4>Datos Adicionales</h4>
                                                        <hr>
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" style="max-width:8vw !important">
                                                        <label>Gross Profit %</label>
                                                        <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0 %"  :minus="false" @input="ValidarGross();CalcularGastoOperaciones();CalcularUtilidadAprox();" class="form-control"  currency="" separator="," :precision="0" v-model="cotizacion_servicio.GrossProfit"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.GrossProfit" :Mensaje="errorvalidacion.GrossProfit[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" style="max-width:9vw !important">
                                                        <label>Factor Hora Extra %</label>
                                                        <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0 %"  :minus="false" @blur="ValidarGross" class="form-control"  currency="" separator="," :precision="0" v-model="cotizacion_servicio.FactorHoraExtra"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.FactorHoraExtra" :Mensaje="errorvalidacion.FactorHoraExtra[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" style="max-width:9vw !important">
                                                        <label>Utilidad Aprox. %</label>
                                                        <vue-numeric placeholder="0 %" disabled :minus="false" @input="ValidarGross" class="form-control"  currency="" separator="," :precision="0" v-model="cotizacion_servicio.Utilidad"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Utilidad" :Mensaje="errorvalidacion.Utilidad[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-3 col-lg-3" style="max-width:9vw !important">
                                                        <label>Gasto Operaciones %</label>
                                                        <vue-numeric placeholder="0 %" disabled :minus="false" @input="ValidarGross" class="form-control"  currency="" separator="," :precision="0" v-model="cotizacion_servicio.GastoOperaciones"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.GastoOperaciones" :Mensaje="errorvalidacion.GastoOperaciones[0]"></Cvalidation></label>
                                                    </div>
                                                </div>
                                                <div class="row mb-3">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <label>Descripción de la Propuesta <small>(max. 950 caracteres)</small> <span v-show="cotizacion_servicio.Propuesta==1">*</span></label>
                                                        <textarea ref="descripcionpropuesta" @input="ContarCaracteresDescripcion" maxlength="950" :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="Descripción"  class="form-control" v-model="cotizacion_servicio.Observaciones" cols="10" rows="3"></textarea>
                                                    </div>
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 d-flex justify-content-end">
														<span class="contadorcaracteres">{{CaracteresDescripcionActual}}</span>
														<span class="contadorcaracteres">{{' /' + 950}}</span>
													</div>
                                                </div>
												<!-- <div class="row mb-3">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <label>Términos y Condiciones</label>
                                                        <textarea placeholder="Términos y Condiciones"  class="form-control" v-model="cotizacion_servicio.Terminos" cols="10" rows="4"></textarea>
                                                    </div>
                                                </div> -->
                                            </div>
                                            <div class="tab-pane fade" id="nav-obra" role="tabpanel" aria-labelledby="obra-tab">
                                                <table class="table table-sm table-02 mt-4">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center colum01" style="width:15%">Personal</th>
															<th class="text-center colum01" style="width:10%">Unidad</th>
                                                            <th class="text-center colum01" style="width:13%">Costo</th>
                                                            <th class="text-center colum01" style="">Tiempo Normal</th>
                                                            <th class="text-center colum01" style="">Tiempo Extra</th>
                                                            <th class="text-center colum01" style="width:12%">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in cotizacion_servicio.ListaManoObra" :key="index">
                                                            <td v-if="!item.Input">
                                                                {{item.Categoria}}
                                                            </td>
															<td v-else>
																<input :disabled="cotizacion_servicio.IdPropuesta!=0" type="text" class="form-control form-control-sm" placeholder="Personal" v-model="item.Categoria">
															</td>
															<td>
																<select :disabled="cotizacion_servicio.IdPropuesta!=0" @change="CalcularTotalCostoDesplazamiento();cal_costoMO(index)" class="form-control form-control-sm" v-model="item.Unidad">
																	<option value="Hora">Hora</option>
																	<option value="Dia">Dia</option>
																</select>
																<!-- <input type="text" class="form-control form-control-sm" placeholder="Unidad" v-model="item.Unidad"> -->
															</td>
                                                            <td class="d-flex justify-content-center">
                                                                <p v-if="item.Input" >
                                                                    <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0"  @input="CalcularTotalCostoDesplazamiento();cal_costoMO(index)" placeholder="$ 0.00" :minus="false"  class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.CostoMO"></vue-numeric>
                                                                    <!-- <Cmoneda  @blur="cal_costoMO(index)"  :activo="false" :clase="'form-control form-finanza form-control-sm text-left'"  :readonly="false"     :minus="true"        currency="$" separator="," :precision="Decimal" v-model="item.costoMO"></Cmoneda> -->
                                                                </p>
                                                                <p v-else>
                                                                    $ {{item.CostoMO}}
                                                                </p>
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0"  @input="CalcularTotalCostoDesplazamiento();cal_costoMO(index)" placeholder="0.0" :minus="false"  class="form-control form-control-sm  w-04"  currency="" separator="," :precision="1" v-model="item.HoraNormal"></vue-numeric>
                                                                <!-- <Cmoneda  @input="cal_costoMO(index)"  :activo="false" :clase="'form-control form-finanza form-control-sm text-left'"  :readonly="false"     :minus="true"        currency="$" separator="," :precision="Decimal" v-model="item.horaNormal"></Cmoneda> -->
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0"  @input="CalcularTotalCostoDesplazamiento();cal_costoMO(index)" placeholder="0.0" :minus="false"  class="form-control form-control-sm  w-04"  currency="" separator="," :precision="1" v-model="item.HoraExtra"></vue-numeric>
                                                                <!-- <Cmoneda  @input="cal_costoMO(index)"  :activo="false" :clase="'form-control form-finanza form-control-sm text-left'"  :readonly="false"     :minus="true"        currency="$" separator="," :precision="Decimal" v-model="item.horaExtra"></Cmoneda> -->
                                                            </td>
                                                            <td>
                                                                <vue-numeric  disabled  :minus="false" placeholder="$ 0.00" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.TotalIndividual"></vue-numeric>
                                                                <!-- <Cmoneda  @input="cal_costoMO(index)"  :activo="true" :clase="'form-control form-finanza form-control-sm text-left'"  :readonly="true"     :minus="true"        currency="$" separator="," :precision="Decimal" v-model="item.totalIndividual"></Cmoneda> -->
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="5" class="text-right">
                                                                Total Con Traslado
                                                            </td>
                                                            <td colspan="1">
                                                                <vue-numeric  disabled placeholder="$ 0.0"  :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalManoDeObra"></vue-numeric>
                                                                <!-- <Cmoneda  :activo="true" :clase="'form-control form-finanza form-control-sm text-left'"  :readonly="true"     :minus="true"        currency="$" separator="," :precision="Decimal" v-model="cotizacion_servicio.TotalManoDeObra"></Cmoneda> -->
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="tab-pane fade" id="nav-material" role="tabpanel" aria-labelledby="material-tab">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                                                        <form class="form-inline float-right">
                                                            <!-- <button @click="add_Materiales(undefined)" type="button" class="btn btn-01 add mx-sm-2">
                                                                Agregar Fila
                                                            </button> -->
                                                            <!-- <button  data-toggle="modal" data-target="#ModalForm" type="button" class="btn btn-01 add">Agregar</button> -->
                                                        </form>
                                                    </div>
                                                </div>

                                                <table class="table table-sm table-03 mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:9% !important;" class="text-center colum02">SKU</th>
                                                            <th style="width:8% !important;" class="text-center colum02">Ítem</th>
															<th style="width:42% !important;" class="text-center colum02">Descripción</th>
															<th style="width:8% !important;" class="text-center colum02">Marca</th>
                                                            <th style="width:7% !important;" class="text-center colum02">Unidad</th>
															<th style="width:11% !important;" class="text-center colum02">Costo Unitario</th>
															<th style="width:6% !important;" class="text-center colum02">Cantidad</th>
                                                            <th class="text-center colum02">Total</th>
                                                            <th class="text-center colum02"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in cotizacion_servicio.ListaMaterialCot" :key="index">
                                                            <td v-b-tooltip.hover.top :title="item.Codigo">
                                                                <input placeholder="SKU"  v-model="item.Codigo" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
                                                            <td v-b-tooltip.hover.top :title="item.Item">
                                                                <input placeholder="Ítem"  v-model="item.Item" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.NombreMat">
                                                                <input maxlength="70" placeholder="Descripción"  v-model="item.NombreMat" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Marca">
                                                                <input maxlength="70" placeholder="Marca"  v-model="item.Marca" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Unidad">
                                                                <input placeholder="Unidad"  v-model="item.Unidad" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="$ 0.00" @input="calcula_importe_material(item)" :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="1" v-model="item.CostoUnitario"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0" @input="calcula_importe_material(item)" :minus="false" class="form-control form-control-sm"  currency="" separator="," :precision="1" v-model="item.Cantidad"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric placeholder="$ 0.00" disabled :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.TotalIndividual"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <button v-if="cotizacion_servicio.IdPropuesta==0" @click="delete_mat(index);" type="button" href="#" class="btn-icon-02">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="7" class="text-right">Total</td>
                                                            <td colspan="1" class="text-right">
                                                                <vue-numeric disabled placeholder="$ 0.00" :minus="true" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalMateriales2"></vue-numeric>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
											<div class="tab-pane fade" id="nav-refaccion" role="tabpanel" aria-labelledby="refaccion-tab">
												<div class="row">
													<div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
														<form class="form-inline float-right">
															<!-- <button data-toggle="modal" data-target="#ModalForm4" type="button" class="btn btn-01 add">Agregar</button> -->
														</form>
													</div>
												</div>
												<table class="table table-sm table-03 mt-3">
													<thead>
                                                        <tr>
                                                            <th style="width:9% !important;" class="text-center colum02">SKU</th>
															<th style="width:10% !important;" class="text-center colum02">Ítem</th>
                                                            <th style="width:41% !important;" class="text-center colum02">Descripción</th>
															<th style="width:8% !important;" class="text-center colum02">Marca</th>
															<!-- <th style="width:9% !important;" class="text-center colum02">Modelo</th> -->
															<!-- <th style="width:7% !important;" class="text-center colum02">N° Parte</th> -->
                                                            <th style="width:6% !important;" class="text-center colum02">Unidad</th>
                                                            <th style="width:11% !important;" class="text-center colum02">Costo Unitario</th>
															<th style="width:6% !important;" class="text-center colum02">Cantidad</th>
                                                            <th style="width:40% !important;" class="text-center colum02">Total</th>
                                                            <th style="width:40% !important;" class="text-center colum02"></th>
                                                        </tr>
                                                    </thead>
													<tbody>
                                                        <tr v-for="(item, index) in cotizacion_servicio.ListaRefaccion" :key="index">
                                                            <td v-b-tooltip.hover.top :title="item.Sku">
                                                                <input placeholder="SKU"  v-model="item.Sku" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
                                                            <td v-b-tooltip.hover.top :title="item.Item">
                                                                <input placeholder="Ítem"  v-model="item.Item" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Descripcion">
                                                                <input maxlength="70" placeholder="Descripción"  v-model="item.Descripcion" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Marca">
                                                                <input maxlength="70" placeholder="Marca"  v-model="item.Marca" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<!-- <td v-b-tooltip.hover.top :title="item.Modelo">
                                                                <input maxlength="70" placeholder="Modelo"  v-model="item.Modelo" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td> -->
															<!-- <td v-b-tooltip.hover.top :title="item.NumParte">
                                                                <input maxlength="70" placeholder="N° Parte"  v-model="item.NumParte" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td> -->
															<td v-b-tooltip.hover.top :title="item.Unidad">
                                                                <input placeholder="Unidad"  v-model="item.Unidad" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="$ 0.00" @input="calcula_importe_refaccion(item)" :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="1" v-model="item.costoUnitario"></vue-numeric>
                                                            </td>
															<td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0" @input="calcula_importe_refaccion(item)" :minus="false" class="form-control form-control-sm"  currency="" separator="," :precision="1" v-model="item.cantidad"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric placeholder="$ 0.00" disabled :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.totalIndividual"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <button v-if="cotizacion_servicio.IdPropuesta==0" @click="delete_refaccion(index);" type="button" href="#" class="btn-icon-02">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="7" class="text-right">Total</td>
                                                            <td colspan="1" class="text-right">
                                                                <vue-numeric disabled placeholder="$ 0.00" :minus="true" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalRefacciones"></vue-numeric>
                                                            </td>
                                                        </tr>
                                                    </tbody>
												</table>
											</div>
                                            <div class="tab-pane fade" id="nav-equipo" role="tabpanel" aria-labelledby="equipo-tab">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                                                        <form class="form-inline float-right">
                                                            <!-- <button @click="add_Equipos(undefined)" type="button" class="btn btn-01 add mx-sm-2">
                                                                Agregar Fila
                                                            </button> -->
                                                            <!-- <button data-toggle="modal" data-target="#ModalForm2" type="button" class="btn btn-01 add">Agregar</button> -->
                                                        </form>
                                                    </div>
                                                </div>
                                                <table class="table table-sm table-03 mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:9% !important;" class="text-center colum02">SKU</th>
															<th style="width:8% !important;" class="text-center colum02">Ítem</th>
                                                            <th style="width:38% !important;" class="text-center colum02">Descripción</th>
															<th style="width:10% !important;" class="text-center colum02">Marca</th>
															<!-- <th style="width:10% !important;" class="text-center colum02">Modelo</th> -->
                                                            <th style="width:6% !important;" class="text-center colum02">Unidad</th>
                                                            <th style="width:11% !important;" class="text-center colum02">Costo Unitario</th>
															<th style="width:7% !important;" class="text-center colum02">Cantidad</th>
                                                            <th style="width:11% !important;" class="text-center colum02">Total</th>
                                                            <th class="text-center colum02"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in cotizacion_servicio.ListaEquipoCot" :key="index">
                                                            <td v-b-tooltip.hover.top :title="item.Codigo">
                                                                <input placeholder="SKU"  v-model="item.Codigo" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
                                                            <td v-b-tooltip.hover.top :title="item.Item">
                                                                <input placeholder="Ítem"  v-model="item.Item" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Nombre">
                                                                <input maxlength="70" placeholder="Descripción"  v-model="item.Nombre" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Marca">
                                                                <input maxlength="70" placeholder="Marca"  v-model="item.Marca" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<!-- <td v-b-tooltip.hover.top :title="item.Modelo">
                                                                <input maxlength="70" placeholder="Modelo"  v-model="item.Modelo" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td> -->
															<td v-b-tooltip.hover.top :title="item.Unidad">
                                                                <input placeholder="Unidad"  v-model="item.Unidad" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="$ 0.00" @input="calcula_importe_equipo(item)" :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.costoUnitario"></vue-numeric>
                                                            </td>
															<td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0" @input="calcula_importe_equipo(item)" :minus="false" class="form-control form-control-sm"  currency="" separator="," :precision="0" v-model="item.cantidad"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric placeholder="$ 0.00" disabled :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.totalIndividual"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <button v-if="cotizacion_servicio.IdPropuesta==0" @click="delete_equipo(index);" type="button" href="#" class="btn-icon-02">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="7" class="text-right">Total</td>
                                                            <td colspan="1" class="text-right">
                                                                <vue-numeric disabled placeholder="$ 0.00" :minus="true" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalEquipos"></vue-numeric>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="tab-pane fade" id="nav-contratista" role="tabpanel" aria-labelledby="contratista-tab">
                                                <!-- <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                                                        <form class="form-inline float-right">
                                                            <button @click="add_Contratistas(undefined)" type="button" class="btn btn-01 add mx-sm-2">
                                                                Agregar
                                                            </button>
                                                        </form>
                                                    </div>
                                                </div> -->
                                                <table class="table table-sm table-03 mt-3">
                                                    <thead>
                                                        <tr>
															<th style="width:10% !important;" class="text-center colum02">Ítem</th>
															<th style="width:12% !important;" class="text-center colum02">Proveedor</th>
                                                            <th style="width:35% !important;" class="text-center colum02">Descripción</th>
															<th style="width:7% !important;" class="text-center colum02">Unidad</th>
															<th style="width:11% !important;" class="text-center colum02">Costo Unitario</th>
                                                            <th style="width:7% !important;" class="text-center colum02">Cantidad</th>
                                                            <th style="width:8% !important;" class="text-center colum02">Total</th>
                                                            <th style="width:7% !important;" class="text-center colum02">Burden</th>
                                                            <th class="text-center colum02"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in cotizacion_servicio.ListaContratista" :key="index">
                                                            <td v-b-tooltip.hover.top :title="item.Item">
                                                                <input placeholder="Ítem"  v-model="item.Item" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Proveedor">
                                                                <input placeholder="Proveedor"  v-model="item.Proveedor" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Nombre">
                                                                <input maxlength="70" placeholder="Descripción"  v-model="item.Nombre" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td>
                                                                <!-- <input placeholder="Unidad"  v-model="item.Unidad" type="text" class="form-control form-control-sm" :disabled="item.blocked"> -->
																<select :disabled="cotizacion_servicio.IdPropuesta!=0" @change="calcula_importe_contratista(item)" class="form-control form-control-sm" v-model="item.Unidad" id="">
																	<option value="Hora">Hora</option>
																	<option value="Dia">Día</option>
																</select>
                                                            </td>
															<td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="$ 0.00" @input="calcula_importe_contratista(item)" :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.CostoUnitario"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0" @input="calcula_importe_contratista(item)" :minus="false" class="form-control form-control-sm"  currency="" separator="," :precision="0" v-model="item.Cantidad"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric placeholder="$ 0.00" disabled :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.TotalIndividual"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric placeholder="$ 0.00" disabled :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.Burden"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <button v-if="cotizacion_servicio.IdPropuesta==0" @click="delete_contratista(index);" type="button" href="#" class="btn-icon-02">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="6" class="text-right">Total</td>
                                                            <td colspan="1" class="text-right">
                                                                <vue-numeric disabled placeholder="$ 0.00" :minus="true" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalContratistas"></vue-numeric>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="tab-pane fade" id="nav-viatico" role="tabpanel" aria-labelledby="viatico-tab">
                                                <!-- <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right">
                                                        <form class="form-inline float-right">
                                                            <button @click="add_Viaticos(undefined)" type="button" class="btn btn-01 add mx-sm-2">
                                                                Agregar
                                                            </button>
                                                        </form>
                                                    </div>
                                                </div> -->
                                                <table class="table table-sm table-03 mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:10% !important;" class="text-center colum02">Ítem</th>
															<th style="width:50% !important;" class="text-center colum02">Descripción</th>
                                                            <th style="width:8% !important;" class="text-center colum02">Unidad</th>
															<th style="width:8% !important;" class="text-center colum02">Cantidad</th>
                                                            <th style="width:11% !important;" class="text-center colum02">Costo Unitario</th>
                                                            <th class="text-center colum02">Total</th>
                                                            <th class="text-center colum02"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in cotizacion_servicio.ListaViatico" :key="index">
                                                            <td v-b-tooltip.hover.top :title="item.Item">
                                                                <input placeholder="Item"  v-model="item.Item" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Nombre">
                                                                <input maxlength="70" placeholder="Descripción"  v-model="item.Nombre" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
															<td v-b-tooltip.hover.top :title="item.Unidad">
                                                                <input maxlength="70" placeholder="Unidad"  v-model="item.Unidad" type="text" class="form-control form-control-sm" :disabled="item.blocked">
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="0" @input="calcula_importe_viatico(item)" :minus="false" class="form-control form-control-sm"  currency="" separator="," :precision="0" v-model="item.Cantidad"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric :disabled="cotizacion_servicio.IdPropuesta!=0" placeholder="$ 0.00" @input="calcula_importe_viatico(item)" :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.CostoUnitario"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <vue-numeric placeholder="$ 0.00" disabled :minus="false" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="item.TotalIndividual"></vue-numeric>
                                                            </td>
                                                            <td>
                                                                <button v-if="cotizacion_servicio.IdPropuesta==0" @click="delete_viatico(index);" type="button" href="#" class="btn-icon-02">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="5" class="text-right">Total</td>
                                                            <td colspan="1" class="text-right">
                                                                <vue-numeric disabled placeholder="$ 0.00" :minus="true" class="form-control form-control-sm"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalViaticos"></vue-numeric>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-5 col-lg-2 mb-01 pl-0">
                                <div class="row justify-content-center">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="card card-03">
                                            <div class="card-header pb-1">
                                                <h4 class="text-white">Folio: {{cotizacion_servicio.Folio}} | Resumen</h4>
                                            </div>
                                            <div class="card-body mt-0 pt-1 mb-0 pb-0">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-0 pb-0" style="height:6.5vh !important">
                                                        <label>Materiales</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalMateriales"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalMateriales" :Mensaje="errorvalidacion.TotalMateriales[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-0 pt-0" style="height:6.5vh !important">
                                                        <label>Equipos</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalEquipos"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalEquipos" :Mensaje="errorvalidacion.TotalEquipos[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label>Mano de Obra</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalManoDeObra"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalManoDeObra" :Mensaje="errorvalidacion.TotalManoDeObra[0]"></Cvalidation></label>
                                                    </div>
													<div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label>Vehículos</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalCostoKm"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalCostoKm" :Mensaje="errorvalidacion.TotalCostoKm[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label>Contratistas</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalContratistas"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalContratistas" :Mensaje="errorvalidacion.TotalContratistas[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label>Viaticos</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalViaticos"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalViaticos" :Mensaje="errorvalidacion.TotalViaticos[0]"></Cvalidation></label>
                                                    </div>
													<div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label>Burden</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.CostoBurden"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CostoBurden" :Mensaje="errorvalidacion.CostoBurden[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label>Garantía</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm "  currency="$" separator="," :precision="0" v-model="TotalGarantia"></vue-numeric>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <hr class="total mt-1">
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="height:6.5vh !important">
                                                        <label class="lab-01">Costo Total</label>
                                                        
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm bold"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.TotalGlobal"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TotalGlobal" :Mensaje="errorvalidacion.TotalGlobal[0]"></Cvalidation></label>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                        <label class="lab-01">Valor Venta</label>
                                                        <vue-numeric disabled placeholder="$ 0.00"  :minus="true" class="form-control form-control-sm numer border-yellow bold"  currency="$" separator="," :precision="0" v-model="cotizacion_servicio.ValorVenta"></vue-numeric>
                                                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.ValorVenta" :Mensaje="errorvalidacion.ValorVenta[0]"></Cvalidation></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
								<div class="col-lg-12 m-0 p-0 text-right mt-3">
									
							<!-- <button v-if="cotizacion_servicio.Propuesta=='0'" :disabled="disableBtn" type="button" class="btn btn-01" @click="Guardar">
									<i v-show="disableBtn" class="fa fa-spinner fa-pulse fa-1x"></i>
									<i v-show="!disableBtn" class="fa fa-plus-circle"></i> 
									Guardar
								</button> -->
								</div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-0 pt-0 text-right">
								<button
								:disabled="disableBtn"
								@click="Volver"
								type="button"
								class="btn btn-04 ban mr-2"
							>
								{{ 'Cancelar' }}
							</button>
							<span v-if="cotizacion_servicio.IdPropuesta==0">
								<button v-if="cotizacion_servicio.Propuesta=='0'" :disabled="disableBtn" type="button" class="btn btn-01" @click="Guardar">
									<i v-show="disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!disableBtn" class="fa fa-plus-circle"></i> 
									Guardar
								</button>
								<button v-else data-toggle="modal" :data-target="cotizacion_servicio.Observaciones!='' ? '#Propuesta' : ''"  data-backdrop="static" :disabled="disableBtn || Ocliente.IdClienteS==0" type="button" class="btn btn-01" @click="GenerarPropuesta">
									<i v-show="disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!disableBtn" class="fa fa-plus-circle"></i> 
									Generar Propuesta
								</button>
							</span>
							<span v-else>
								<button :disabled="disableBtn" type="button" class="btn btn-01" @click="GenerarOtraPropuesta">
									<i v-show="disableBtn" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
									<i v-show="!disableBtn" class="fa fa-plus-circle"></i> 
									Generar Otra Propuesta
								</button>
							</span>
							</div>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>

        <Modal :Nombre="'Materiales'" :size="size">
            <template slot="Form" >
                <Cmateriales :pTipo="2"></Cmateriales>
            </template>
        </Modal>

        <Modal :Nombre="'Equipos'" :size="size" :NameModal="'ModalForm2'">
            <template slot="Form" >
                <Cequipos :pTipo="2"></Cequipos>
            </template>
        </Modal>

		<Modal :Nombre="'Refacciones'" :size="size" :NameModal="'ModalForm4'">
            <template slot="Form" >
                <Crefacciones :pTipo="2"></Crefacciones>
            </template>
        </Modal>

		<Modal :poBtnSave="oBtnSavePropuesta" :Nombre="ConfigModalPropuesta.Nombre" :size="'modal-lg'" :pEmitSeccion="ConfigModalPropuesta.EmitSeccion" :NameModal="ConfigModalPropuesta.nameModal" :Showbutton="false">
            <template slot="Form" >
                <Cpropuestas :pOrigen="'cotizacion'" :pVendedor="Vendedor" :pIdClienteS="Ocliente.IdClienteS" :poBtnSave="oBtnSavePropuesta"></Cpropuestas>
            </template>
        </Modal>

        <Ccliente :TipoModal='1' :Origen="'Factura'"></Ccliente>
    </div>
</template>

<script>
import Modal from '@/components/Cmodal.vue';
import Cmateriales from '@/views/modulos/almacen/materiales/List.vue';
import Cequipos from '@/views/modulos/almacen/equipos/List.vue';
import Crefacciones from '@/views/modulos/almacen/refacciones/List.vue';
import Cpropuestas from '@/views/catalogos/propuestas/Form.vue';
import Ccliente from '@/components/Ccliente.vue';
export default {
    name:'FormCotizacion',
    props:['NameList','Id','objsucursal'],
    components:{
        Modal,Ccliente,Cmateriales,Cequipos,Crefacciones,Cpropuestas
    },
    data() {
        return {
			nameBtnSave:'Guardar',
            BtnBuscar:false,
            Modal:true,//Sirve pra los botones de guardado
            FormName:'Cotizacion',//Sirve para donde va regresar
            size :"modal-xxl",
            ListaClientes:[],
            ListaSucursal:[],
            Mostrar:true,
            Regresar:false,
            TituloLista:'Lista de Clientes',
            Ocliente:{IdClienteS:0,IdCliente:0,Nombre:'',Direccion:'',Telefono:'',Correo:''},
            urlApiCostoKm:"costoskm/get",
            Listacostoskm:[],
            ValorKMData:0,
            urlApiMo:"cotizacion_servicio/listmo",
            ListManoObraCot:[],
            InicioCalculo:0,
            Burden:0,
			BurdenDia:0,
            TotalGarantia:0,
            cotizacion_servicio:{
                IdServicio:0,
                IdCotizacionServicio:0,
				IdPropuesta:0,
                IdCliente:0,
                GrossProfit:0,
                Utilidad:0,
                GastoOperaciones:0,
                FactorHoraExtra:0,
                TotalMateriales:0,
				TotalMateriales2:0,
				TotalRefacciones:0,
                TotalEquipos:0,
                TotalContratistas:0,
                TotalViaticos:0,
                TotalManoDeObra:0,
                TotalMiscelaneos:0,
                CostoKm:0,
                TotalGlobal:0,
                Distancia:0,
                Velocidad:0,
                TotalCostoKm:0,
                Garantia:0,
                CostoBurden:0,
                CostoDesplazamiento:0,
                CostoManoObraD:0,
                ValorVenta:0,
				Observaciones:'',
				Propuesta:0,
				// Terminos:'',
                ListaManoObra:[],
                ListaMaterialCot:[],
                ListaEquipoCot:[],
                ListaMiscelaneCot:[],
                ListaContratista:[],
                ListaViatico:[],
				ListaRefaccion:[],
				ObjPropuesta:{},
				NombreArchivo:'',
				NombreArchivoFile:null,
				IdEquipo:null,
				NombrePropuesta:''
				// VerDesglose:false
            },
			ValorVentaCopia:0,
            ConfigLoad:{
                ShowLoader:false,
                ClassLoad:true,
            },
            ShowComponents:false,
            errorvalidacion:[],
            oHead:{//Encabezado
                Title:'Cotizacion de servicio',
                BtnNewShow:false,
                BtnNewName:'Nuevo',
                isreturn:true,
                isModal:false,
                isEmit:false,
                Url:'cotizacion_list',
                ObjReturn:'',
             },
            Listamarkup:[],
            isOverlay: true,
			ConfigModalPropuesta:{
				isModal:true,
				EmitSeccion:'Propuesta',
				nameModal:'Propuesta',
				Nombre:'Propuesta'
			},
			disableBtn:false,
			oBtnSavePropuesta:{
				disableBtn:false,
                toast:0,
                nombreModal:"Propuesta",
                EmitSeccion:"Propuesta"
			},
			Botones:{
				Datos:true,
				Materiales:false,
				Refacciones:false,
				Equipos:false,
				ManoDeObra:false,
				Contratistas:false,
				Viaticos:false
			},
			Equipos:[],
			EquiposCopia:[],
			Vendedor:{
				IdVendedor:0,
				Nombre:0,
				Telefono:0,
				Correo:0
			},
			IdUsuario:0,
			CaracteresDescripcionActual:0
        }
    },
    methods: {
		ContarCaracteresDescripcion(){
			// console.log(this.$refs.descripcionpropuesta.value.length);
			this.CaracteresDescripcionActual=this.$refs.descripcionpropuesta.value.length;
		},
		GetExistVendedor(){
			this.$http.get('vendedorcotizacionusuario/recovery',{
				params:{
					IdUsuario:this.IdUsuario
				}
			}).then((res)=>{
				this.Vendedor=res.data.data.vendedor;
			}).catch((err)=>{

			})
		},
		CambiarPestania(index){
			let Botones=this.Botones;
			Object.keys(Botones).forEach(function(key,ind){
				if (key==index) {
					Botones[key]=true;
				}
				else{
					Botones[key]=false;
				}
				// console.log(index)
			});
		},
        async get_ListaMarkup()
		{
			await this.$http.get(
				'markup/get',
				{
					params:{
						Nombre:'',
						Entrada:500,
						pag:0,
						RegEstatus:'A'
					}
				}
			).then( (res) => {
				this.Listamarkup =res.data.data.row;
			});
		},
        async Get_Recovery(){
            this.ConfigLoad.ShowLoader=true;
            // this.ConfigLoad.ClassLoad=false;
			await this.$http.get('cotizacion_servicio/recovery', {
				params:{
					IdCotizacionServicio: this.cotizacion_servicio.IdCotizacionServicio
				}
			}).then((res) => {
                if (res.data.data.cotizacion_servicio.TotalEquipos=='' || res.data.data.cotizacion_servicio.TotalEquipos==null) {
                    res.data.data.cotizacion_servicio.TotalEquipos=0;
                }
                if (res.data.data.cotizacion_servicio.TotalContratistas=='' || res.data.data.cotizacion_servicio.TotalContratistas==null) {
                    res.data.data.cotizacion_servicio.TotalContratistas=0;
                }
                if (res.data.data.cotizacion_servicio.TotalViaticos=='' || res.data.data.cotizacion_servicio.TotalViaticos==null) {
                    res.data.data.cotizacion_servicio.TotalViaticos=0;
                }
				// this.cotizacion_servicio	= res.data.data.cotizacion_servicio;
                this.cotizacion_servicio.IdCotizacionServicio	= res.data.data.cotizacion_servicio.IdCotizacionServicio;
				this.cotizacion_servicio.IdPropuesta	= res.data.data.cotizacion_servicio.IdPropuesta;
                this.cotizacion_servicio.IdCliente	= res.data.data.cotizacion_servicio.IdCliente;
                this.cotizacion_servicio.IdUsuario	= res.data.data.cotizacion_servicio.IdUsuario;
                this.cotizacion_servicio.IdSucursal	= res.data.data.cotizacion_servicio.IdSucursal;
				this.cotizacion_servicio.NombrePropuesta	= res.data.data.cotizacion_servicio.NombrePropuesta;
                this.cotizacion_servicio.GrossProfit	= res.data.data.cotizacion_servicio.GrossProfit;
                this.cotizacion_servicio.Utilidad	= res.data.data.cotizacion_servicio.Utilidad;
                this.cotizacion_servicio.GastoOperaciones	= res.data.data.cotizacion_servicio.GastoOperaciones;
                this.cotizacion_servicio.FactorHoraExtra	= res.data.data.cotizacion_servicio.FactorHoraExtra;
                this.cotizacion_servicio.TotalMateriales	= res.data.data.cotizacion_servicio.TotalMateriales;
				this.cotizacion_servicio.TotalMateriales2	= res.data.data.cotizacion_servicio.TotalMateriales2 == '' ? res.data.data.cotizacion_servicio.TotalMateriales : res.data.data.cotizacion_servicio.TotalMateriales;
                this.cotizacion_servicio.TotalEquipos	= res.data.data.cotizacion_servicio.TotalEquipos;
                this.cotizacion_servicio.TotalContratistas	= res.data.data.cotizacion_servicio.TotalContratistas;
                this.cotizacion_servicio.TotalViaticos	= res.data.data.cotizacion_servicio.TotalViaticos;
                this.cotizacion_servicio.TotalManoDeObra	= res.data.data.cotizacion_servicio.TotalManoDeObra;
				this.cotizacion_servicio.TotalRefacciones	= res.data.data.cotizacion_servicio.TotalRefacciones;
                this.cotizacion_servicio.Miscelaneos	= res.data.data.cotizacion_servicio.Miscelaneos;
                this.cotizacion_servicio.CostoKm	= res.data.data.cotizacion_servicio.CostoKm;
				// this.cotizacion_servicio.VerDesglose	= res.data.data.cotizacion_servicio.VerDesglose == 0 ? false : true;
                this.cotizacion_servicio.FechaCotiServicio	= res.data.data.cotizacion_servicio.FechaCotiServicio;
                this.cotizacion_servicio.TotalGlobal	= res.data.data.cotizacion_servicio.TotalGlobal;
                this.cotizacion_servicio.Distancia	= res.data.data.cotizacion_servicio.Distancia;
                this.cotizacion_servicio.Velocidad	= res.data.data.cotizacion_servicio.Velocidad;
                this.cotizacion_servicio.RegEstatus	= res.data.data.cotizacion_servicio.RegEstatus;
                this.cotizacion_servicio.Folio	= res.data.data.cotizacion_servicio.Folio;
                this.cotizacion_servicio.TotalCostoKm	= res.data.data.cotizacion_servicio.TotalCostoKm;
                this.cotizacion_servicio.Garantia	= res.data.data.cotizacion_servicio.Garantia;
                this.cotizacion_servicio.Comentario	= res.data.data.cotizacion_servicio.Comentario;
                this.cotizacion_servicio.CostoBurden	= res.data.data.cotizacion_servicio.CostoBurden;
                this.cotizacion_servicio.CostoDesplazamiento	= res.data.data.cotizacion_servicio.CostoDesplazamiento;
                this.cotizacion_servicio.CostoManoObraD	= res.data.data.cotizacion_servicio.CostoManoObraD;
                this.cotizacion_servicio.ValorVenta	= res.data.data.cotizacion_servicio.ValorVenta;
                this.cotizacion_servicio.FechaMod	= res.data.data.cotizacion_servicio.FechaMod;
                this.cotizacion_servicio.Observaciones	= res.data.data.cotizacion_servicio.Observaciones;
				// this.cotizacion_servicio.Terminos	= res.data.data.cotizacion_servicio.Terminos;
                this.cotizacion_servicio.IdServicio	= res.data.data.cotizacion_servicio.IdServicio;
                this.cotizacion_servicio.Estatus	= res.data.data.cotizacion_servicio.Estatus;
				this.cotizacion_servicio.Propuesta	= res.data.data.cotizacion_servicio.Propuesta;
				this.cotizacion_servicio.IdEquipo	= res.data.data.cotizacion_servicio.IdEquipo;

				/// MAPPING DATA - Anexa atributo de bloqueo para deshabilitar la modificaion del nombre del material.
				let tmpMaterial = [];
				tmpMaterial = res.data.data.cotizacion_servicio.ListaMaterialCot.map( item => ({
					IdCotizacionServicio : item.IdCotizacionServicio,
					IdMaterial: 	item.IdMaterial,
					// IdMaterialDistribuidor: 	item.IdMaterialDistribuidor,
					// FactorDescuento: 	item.FactorDescuento==0 ? 1 : item.FactorDescuento,
					NombreMat: 		item.NombreMat,
					Item: 		item.Item,
					CostoUnitario: 	item.CostoUnitario,
					Cantidad: 		item.Cantidad,
                    Codigo: item.Codigo,
					TotalIndividual: item.TotalIndividual,
					Unidad: item.Unidad,
					Descripcion: item.Descripcion,
					Marca: item.Marca,
					Modelo: item.Modelo,
					Stock: item.Stock,
					blocked: this.cotizacion_servicio.IdPropuesta!=0 ? true : false
				}));

				let tmpRefaccion = [];
				tmpRefaccion = res.data.data.cotizacion_servicio.ListaRefaccion.map( item => ({
					IdCotizacionServicio : item.IdCotizacionServicio,
					IdRefaccion: 	item.IdRefaccion,
					IdRefaccionDistribuidor: 	item.IdRefaccionDistribuidor,
					FactorDescuento: 	item.FactorDescuento==0 ? 1 : item.FactorDescuento,
					Descripcion: 		item.Nombre,
					costoUnitario: 	item.CostoUnitario,
					cantidad: 		item.Cantidad,
                    Sku: item.Sku,
					totalIndividual: item.TotalIndividual,
					Unidad: item.Unidad,
					Item: item.Item,
					Stock: item.Stock,
					Marca: item.Marca,
					Modelo: item.Modelo,
					NumParte:item.NumParte,
					blocked: this.cotizacion_servicio.IdPropuesta!=0 ? true : false
				}));

                let tmpEquipoCot=[];
                tmpEquipoCot=res.data.data.cotizacion_servicio.ListaEquipoCot.map(item=>({
                    IdCotizacionServicio:item.IdCotizacionServicio,
                    IdEquipoCot:item.IdEquipoCot,
					// IdEquipoCotDistribuidor: 	item.IdEquipoCotDistribuidor,
					// FactorDescuento: 	item.FactorDescuento==0 ? 1 : item.FactorDescuento,
                    Nombre:item.Nombre,
                    costoUnitario:item.CostoUnitario,
                    Codigo: item.Codigo,
                    cantidad:item.Cantidad,
                    totalIndividual:item.TotalIndividual,
					Unidad: item.Unidad,
					Descripcion: item.Descripcion,
					Item: item.Item,
					Stock: item.Stock,
					Marca: item.Marca,
					Modelo: item.Modelo,
                    blocked:this.cotizacion_servicio.IdPropuesta!=0 ? true : false
                }));

				this.cotizacion_servicio.ListaMaterialCot = [];
				this.cotizacion_servicio.ListaMaterialCot = tmpMaterial;

                this.cotizacion_servicio.ListaEquipoCot=[];
                this.cotizacion_servicio.ListaEquipoCot=tmpEquipoCot;

				this.cotizacion_servicio.ListaRefaccion=[];
				this.cotizacion_servicio.ListaRefaccion=tmpRefaccion;

                let tmpContratista=[];
                tmpContratista=res.data.data.cotizacion_servicio.ListaContratista.map(item=>({
                    IdCotizacionServicio:item.IdCotizacionServicio,
                    IdContratista:item.IdContratista,
                    Nombre:item.Nombre,
					Item:item.Item,
                    CostoUnitario:item.CostoUnitario,
                    Cantidad:item.Cantidad,
                    TotalIndividual:item.Valor,
                    Burden:item.Burden,
					Unidad: item.Unidad,
					Proveedor: item.Proveedor,
					Descripcion: item.Descripcion,
                    blocked:this.cotizacion_servicio.IdPropuesta!=0 ? true : false
                }));
                this.cotizacion_servicio.ListaContratista=tmpContratista;
                
                let tmpViatico=[];
                tmpViatico=res.data.data.cotizacion_servicio.ListaViatico.map(item=>({
                    IdCotizacionServicio:item.IdCotizacionServicio,
                    Nombre:item.Descripcion,
					Item:item.Item,
                    CostoUnitario:item.CostoUnitario,
                    Cantidad:item.Cantidad,
					Unidad:item.Unidad,
                    TotalIndividual:item.Valor,
                    blocked:this.cotizacion_servicio.IdPropuesta!=0 ? true : false
                }))
                this.cotizacion_servicio.ListaViatico=tmpViatico;

				this.Ocliente				= res.data.data.Ocliente;
				this.Ocliente.NomCliente=res.data.data.Ocli.Nombre;
				this.ShowComponents			= true;
				if (this.cotizacion_servicio.IdEquipo!=0) {
					this.ListActivos();	
				}
				else{
					this.Equipos.push({id:0,label:''});
				}
				this.ValorVentaCopia	= res.data.data.cotizacion_servicio.ValorVenta;
			}).catch((e) => {
				// this.isOverlay = false;
			}).finally(()=>{
				// this.isOverlay = false;
				this.CaracteresDescripcionActual=this.$refs.descripcionpropuesta.value.length;
                setTimeout(() => {
					// this.CalcularTotalValorVenta();
                    this.isOverlay=false;
                    // this.ConfigLoad.ClassLoad=true;
					this.cotizacion_servicio.ValorVenta=this.ValorVentaCopia;
					this.calcula_total_contratista();
                }, 1300);
			});
		},
        async Guardar(CambiarPropuesta=false)
        {
			this.oBtnSavePropuesta.disableBtn=true;
            this.bus.$emit('BloquearBtn',0);
			let Formulario=this.DatosFormulario(CambiarPropuesta);
            await this.$http.post(
                'cotizacion_servicio/post',
                Formulario,
				{
					headers:{
            	        'Content-Type':'multipart/form-data'
            	    }
				}
            ).then( (res) => {
                this.bus.$emit('BloquearBtn',1);
				if (this.cotizacion_servicio.Propuesta=='1') {
					$('#'+this.ConfigModalPropuesta.EmitSeccion).modal('hide');	
				}
				this.$toast.success('La Cotización se ha Guardado con Éxito');
                this.$router.push({name:'cotizacion_list'});
            }).catch( err => {
					this.oBtnSavePropuesta.disableBtn=false;
					this.disableBtn=false;
                    if(err.response.data.type==2){
                        this.$toast.error(err.response.data.message);
                    }else{
                        this.errorvalidacion=err.response.data.message.errores;
                    }

                this.bus.$emit('BloquearBtn',2);
                this.bus.$emit('Desbloqueo',false);
            });
        },
		GenerarPropuesta(){
			if (this.cotizacion_servicio.Observaciones=='') {
				this.$toast.warning('Campo de Descripción de Propuesta Requerido');
				return false;
			}
			else{
				this.bus.$emit("NewModal_"+this.ConfigModalPropuesta.EmitSeccion,'',0,this.Ocliente,this.Ocliente.IdClienteS,this.cotizacion_servicio.ValorVenta,this.cotizacion_servicio.NombrePropuesta);
			}
			// this.bus.$emit('OpenModal');
		},
		GenerarOtraPropuesta(){
			this.$swal({
                title: 'Esta seguro que desea crear otra propuesta?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    this.Guardar(true);
                }
            });
		},
		DatosFormulario(CambiarPropuesta){
			let formData=new FormData();
			formData.set('IdServicio',this.cotizacion_servicio.IdServicio)
			if (CambiarPropuesta && this.cotizacion_servicio.IdCotizacionServicio>0 && this.cotizacion_servicio.Propuesta=='1') {
				formData.set('IdCotizacionServicioAntiguo',this.cotizacion_servicio.IdCotizacionServicio);
				formData.set('IdCotizacionServicio',0);
				formData.set('Propuesta','0');
			}
			else{
				formData.set('IdCotizacionServicio',this.cotizacion_servicio.IdCotizacionServicio);
				formData.set('Propuesta',this.cotizacion_servicio.Propuesta);
			}
            // formData.set('IdCotizacionServicio',this.cotizacion_servicio.IdCotizacionServicio);
            formData.set('IdCliente',this.cotizacion_servicio.IdCliente);
            formData.set('GrossProfit',this.cotizacion_servicio.GrossProfit);
            formData.set('Utilidad',this.cotizacion_servicio.Utilidad);
            formData.set('GastoOperaciones',this.cotizacion_servicio.GastoOperaciones);
            formData.set('FactorHoraExtra',this.cotizacion_servicio.FactorHoraExtra);
            formData.set('TotalMateriales',this.cotizacion_servicio.TotalMateriales);
			formData.set('TotalMateriales2',this.cotizacion_servicio.TotalMateriales2);
			formData.set('TotalRefacciones',this.cotizacion_servicio.TotalRefacciones);
            formData.set('TotalEquipos',this.cotizacion_servicio.TotalEquipos);
            formData.set('TotalContratistas',this.cotizacion_servicio.TotalContratistas);
            formData.set('TotalViaticos',this.cotizacion_servicio.TotalViaticos);
            formData.set('TotalManoDeObra',this.cotizacion_servicio.TotalManoDeObra);
            formData.set('TotalMiscelaneos',this.cotizacion_servicio.TotalMiscelaneos);
            formData.set('CostoKm',this.cotizacion_servicio.CostoKm);
            formData.set('TotalGlobal',this.cotizacion_servicio.TotalGlobal);
            formData.set('Distancia',this.cotizacion_servicio.Distancia);
            formData.set('Velocidad',this.cotizacion_servicio.Velocidad);
            formData.set('TotalCostoKm',this.cotizacion_servicio.TotalCostoKm);
            formData.set('Garantia',this.cotizacion_servicio.Garantia);
            formData.set('CostoBurden',this.cotizacion_servicio.CostoBurden);
            formData.set('CostoDesplazamiento',this.cotizacion_servicio.CostoDesplazamiento);
            formData.set('CostoManoObraD',this.cotizacion_servicio.CostoManoObraD);
            formData.set('ValorVenta',this.cotizacion_servicio.ValorVenta);
			formData.set('Observaciones',this.cotizacion_servicio.Observaciones);
			// formData.set('Propuesta',this.cotizacion_servicio.Propuesta);
			formData.set('IdEquipo',this.cotizacion_servicio.IdEquipo);
			// formData.set('VerDesglose',this.cotizacion_servicio.VerDesglose == true ? 1 : 0);
            formData.append('ListaManoObra',JSON.stringify(this.cotizacion_servicio.ListaManoObra));
            formData.append('ListaMaterialCot',JSON.stringify(this.cotizacion_servicio.ListaMaterialCot));
            formData.append('ListaEquipoCot',JSON.stringify(this.cotizacion_servicio.ListaEquipoCot));
            formData.append('ListaMiscelaneCot',JSON.stringify(this.cotizacion_servicio.ListaMiscelaneCot));
            formData.append('ListaContratista',JSON.stringify(this.cotizacion_servicio.ListaContratista));
            formData.append('ListaViatico',JSON.stringify(this.cotizacion_servicio.ListaViatico));
			formData.append('ListaRefaccion',JSON.stringify(this.cotizacion_servicio.ListaRefaccion));
			// formData.append('NombreArchivoFile',this.cotizacion_servicio.NombreArchivoFile);
			// formData.append('NombreArchivo',this.cotizacion_servicio.NombreArchivo);
			formData.append('ObjPropuesta',JSON.stringify(this.cotizacion_servicio.ObjPropuesta));
			// formData.set('NombreArchivo')=this.cotizacion_servicio.NombreArchivo
			// formData.set('NombreArchivoFile')=this.cotizacion_servicio.NombreArchivoFile
			return formData;
		},
        ListaCliente(){
            this.bus.$emit('ListCcliente');
        },
        add_datos(oSucursal,oCliente){
            this.Ocliente=oSucursal;
			this.Ocliente.NomCliente=oCliente.Nombre
            this.cotizacion_servicio.IdCliente=this.Ocliente.IdClienteS;

            if(oSucursal.DistanciaAprox > 0){
                this.cotizacion_servicio.Distancia = oSucursal.DistanciaAprox;
            }
			this.Ocliente.Telefono=oCliente.Telefono;
			this.Ocliente.Correo=oCliente.Correo;
			// this.Ocliente.Contacto=oCliente.Contacto;
			this.ListActivos();
			// console.log(oCliente);
        },
        add_datos2(oSucursal){
            this.oHead.Url = 'menulevantamiento';
            this.BtnBuscar = true;
            this.Ocliente=oSucursal;
            this.cotizacion_servicio.IdCliente=this.Ocliente.IdClienteS;
            this.cotizacion_servicio.IdServicio=this.Ocliente.IdServicio;
        },
        // ========================================= DATO =========================================

        async ListarCostoKm()
        {
            await this.$http.get(
                this.urlApiCostoKm,
                {
                    params:{Nombre:'',Entrada:50,pag:0, RegEstatus:'A'}
                }
            ).then( (res) => {
                this.Listacostoskm =res.data.data.row;
            });
        },
        ValidarGross()
        {
            if (this.cotizacion_servicio.GrossProfit !='' && this.cotizacion_servicio.GrossProfit != null)
            {  
                if (parseFloat (this.cotizacion_servicio.GrossProfit)>100)
                {
                this.cotizacion_servicio.GrossProfit =100;  
                }
            }
            this.AgregarFactorExtra();
        },
        CalcularCostoKM(){
            var Distancia= this.cotizacion_servicio.Distancia;
            var valObj = this.Listacostoskm.filter(function(elem){
                if(parseFloat(elem.KMinicial)<=parseFloat(Distancia) && parseFloat(elem.KMfinal)>=parseFloat(Distancia)){
                        return elem;
                }
            });

            var Costo=0;
            if(valObj.length>0){
                Costo=valObj[0].CostoKM;
            }
            this.cotizacion_servicio.CostoKm=parseFloat(Costo);
            this.calcularTotalMO();
            this.CalcularTotalCostoDesplazamiento();
        },
        CalcularGastoOperaciones(){
            var Valor=0;
            if(this.cotizacion_servicio.GrossProfit<=100 && this.cotizacion_servicio.GrossProfit!=""){
                Valor= 100- parseFloat(this.cotizacion_servicio.GrossProfit);
                this.cotizacion_servicio.GastoOperaciones=parseFloat(Valor.toFixed(0));
            }
        },
        CalcularUtilidadAprox(){
            var Valor=0;
            if(this.cotizacion_servicio.GrossProfit>0 && this.cotizacion_servicio.GrossProfit!=""){
                Valor=  parseFloat(this.cotizacion_servicio.GrossProfit)-25;
                this.cotizacion_servicio.Utilidad=parseFloat(Valor.toFixed(0));
            }
            this.CalcularTotalValorVenta();
        },
        // ========================================= MANO DE OBRA =========================================
        async get_list_mo()
        {
            this.isOverlay=true;
            await this.$http.get(
                this.urlApiMo,
                {
                    params:{IdCotizacionServicio:this.cotizacion_servicio.IdCotizacionServicio,Entrada:50,pag:0, RegEstatus:'A'}
                }
            ).then( (res) => {
                this.cotizacion_servicio.ListaManoObra=res.data.data.row;
                this.Burden=res.data.data.Burden;
				this.BurdenDia=res.data.data.BurdenDia;
            }).finally(()=>{
                if (this.cotizacion_servicio.IdCotizacionServicio>0) {
                    this.Get_Recovery();
                }
            });
        },
        cal_costoMO(index){
			if (index<4) {
				if (this.cotizacion_servicio.ListaManoObra[index].Unidad=='Hora' && this.cotizacion_servicio.ListaManoObra[index].CostoHora!='') {
					this.cotizacion_servicio.ListaManoObra[index].CostoMO=this.cotizacion_servicio.ListaManoObra[index].CostoHora;
				}
				else{
					if (this.cotizacion_servicio.ListaManoObra[index].CostoDia!='') {
						this.cotizacion_servicio.ListaManoObra[index].CostoMO=this.cotizacion_servicio.ListaManoObra[index].CostoDia;	
					}
				}	
			}
            var costMO=this.cotizacion_servicio.ListaManoObra[index].CostoMO;
            var burden=this.cotizacion_servicio.ListaManoObra[index].Unidad=='Hora' ? this.cotizacion_servicio.ListaManoObra[index].Burden : this.cotizacion_servicio.ListaManoObra[index].BurdenDia;
            var normal=this.cotizacion_servicio.ListaManoObra[index].HoraNormal;
            var factor=this.cotizacion_servicio.FactorHoraExtra;
            var extra=this.cotizacion_servicio.ListaManoObra[index].HoraExtra;

            if(costMO==''){costMO=0;}
            if(burden==''){burden=0;}
            if(normal==''){normal=0;}
            if(factor==''){factor=0;}
            if(extra==''){extra=0;}
            // if (index<4)
            // {
            //     var resultado = eval (  parseFloat(costMO ) * parseFloat(normal) + (parseFloat( costMO) +( parseFloat(costMO)*(parseFloat(factor)/100) )) *  parseFloat(extra) * parseFloat(extra) ); 
           
            //     this.cotizacion_servicio.ListaManoObra[index].TotalIndividual= resultado.toFixed(2);
            // }
            // else{
            //     resultado=(parseFloat(costMO) + parseFloat(factor)/100)*(parseFloat(normal)+(parseFloat(extra)*(parseFloat(factor)/100)));
            //     this.cotizacion_servicio.ListaManoObra[index].TotalIndividual=resultado.toFixed(2);
                
            // }
			var resultado = eval (  parseFloat(costMO ) * parseFloat(normal) + (parseFloat( costMO) +( parseFloat(costMO)*(parseFloat(factor)/100) )) *  parseFloat(extra) * parseFloat(extra) ); 
           
            this.cotizacion_servicio.ListaManoObra[index].TotalIndividual= resultado.toFixed(2);
            this.calcularTotalMO();
        },

        AgregarFactorExtra(){
            let Contador = 0;

            this.cotizacion_servicio.ListaManoObra.forEach(element => {
                this.cal_costoMO(Contador);
                Contador++;
            });
        },
        calcularTotalMO(){
            var Total=0;
            this.cotizacion_servicio.ListaManoObra.forEach(element => {
                if(element.TotalIndividual!=''){
                    Total+=parseFloat(element.TotalIndividual);
                }
            });
            // console.log(this.cotizacion_servicio.ListaManoObra);

            this.cotizacion_servicio.TotalManoDeObra= Total.toFixed(0);
			// console.log(this.cotizacion_servicio.TotalManoDeObra);
            this.CalcularTotalMODesplazamiento();
            this.CalcularTotalCostoBurden();
        },

        // ========================================= MATERIAL =========================================

        add_Materiales(obj){
            let IdMaterial	= 0;
            let NomMaterial	= '';
            let Precio		= 0;
			let blocker = false;
            let Codigo = '';
			let Unidad = '';
			let Item = '';
			let Marca = '';
			let Modelo = '';
			let Stock = 0;

            if(obj !== undefined) {
               IdMaterial 	= parseInt(obj.IdMaterial);
               NomMaterial 	= obj.NomMaterial.trim();
			   Unidad 	= obj.Unidad.trim();
			   Item 	= obj.Item!=null ? obj.Item.trim() : '';
               Precio 		= parseFloat(obj.Precio);
			   Stock 		= parseInt(obj.Stock);
               Codigo 	= obj.Codigo!=null ? obj.Codigo.trim() : '';
			   Marca 	= obj.Marca!=null ? obj.Marca.trim() : '';
			   Modelo 	= obj.Modelo!=null ? obj.Modelo.trim() : '';

			   // EVALUA SI EL MATERIAL NO YA HA SIDO AGREGADO, EVITA QUE SE REPITA DICHO ELEMENTO EN LA LISTA
			   let valObj = this.cotizacion_servicio.ListaMaterialCot.filter(function(elem) {
                    if(elem.IdMaterial === obj.IdMaterial) {
                        return elem.IdMaterial;
                    }
                });

			   if(valObj.length > 0){
				   return false;
			   }

				blocker = true;

            }

			let lista = {
				IdMaterial: IdMaterial,
				NombreMat: NomMaterial,
				CostoUnitario: Precio,
				Cantidad: 1,
				TotalIndividual: Precio,
				blocked: blocker,
                Codigo: Codigo,
				Unidad:Unidad,
				Item:Item,
				Stock:Stock,
				Marca:Marca,
				Modelo:Modelo,
			};

			this.cotizacion_servicio.ListaMaterialCot.push(lista);


        },

        calcula_importe_material(item) {
            let Precio	 	= parseFloat(item.CostoUnitario);
            let Cantidad 	= parseFloat(item.Cantidad);
			// let FactorDescuento=parseFloat(item.FactorDescuento);
			// console.log(FactorDescuento);

            let Resultado  	= (Precio * Cantidad);

            // MARKUP - SE UBICA CON IMPORTE DEL MATERIAL EL RANGO EN EL QUE CALIFICA PARA TENER EL VALOR DE MARKUP
            let valObj = this.Listamarkup.filter(function(elem) {
                if(parseFloat(elem.Monto_I) <= Resultado && parseFloat(elem.Monto_F) >= Resultado) {
					return elem;
                }
            });

            let CostoMarkup = 0;
            if(valObj.length > 0){
				CostoMarkup = parseFloat(valObj[0].CostoM);
            }


			if(CostoMarkup === 0){CostoMarkup=0}
            if(Precio === 0){Precio=0}
            if(Cantidad === 0){Cantidad=0}
            if(Resultado === 0){Resultado=0}

            let subTotal = isNaN( (Resultado * CostoMarkup) ) ? 0 : (Resultado * CostoMarkup);

			item.TotalIndividual = subTotal.toFixed(2);


           this.calcula_total_material();
        },

		calcula_total_material(){
			let Total = 0;
			this.cotizacion_servicio.ListaMaterialCot.forEach(element => {
				if(parseFloat(element.TotalIndividual) !== 0){
					Total+=parseFloat(element.TotalIndividual);
				}
			});

			let subTotal = isNaN(Total) ? 0 : Total;
			this.cotizacion_servicio.TotalMateriales2 = subTotal.toFixed(2);
			this.cotizacion_servicio.TotalMateriales = this.cotizacion_servicio.TotalRefacciones != 0 ? (subTotal+parseFloat(this.cotizacion_servicio.TotalRefacciones)).toFixed(2) : subTotal.toFixed(2);
            this.CalcularTotalGarantia();
		},

        delete_mat(index) {
            this.cotizacion_servicio.ListaMaterialCot.splice(index, 1);
			this.calcula_total_material();
        },

        // ========================================= EQUIPO =========================================

        add_Equipos(obj){
            let IdEquipoCot	= 0;
            let Nombre	= '';
            let Precio		= 0;
			let blocker = false;
            let Codigo = '';
			let Unidad = '';
			let Item = '';
			let Marca = '';
			let Modelo = '';
			let Stock = 0;

            if(obj !== undefined) {
               IdEquipoCot 	= parseInt(obj.IdEquipoCot);
               Nombre 	= obj.Nombre.trim();
               Precio 		= parseFloat(obj.Precio);
               Codigo 	= obj.Codigo.trim();
			   Item 	= obj.Item!=null ? obj.Item.trim() : '';
			   Marca 	= obj.Marca!=null ? obj.Marca.trim() : '';
			   Modelo 	= obj.Modelo!=null ? obj.Modelo.trim() : '';
			   Unidad 	= obj.Unidad.trim();
			   Stock 		= parseFloat(obj.Stock);

			   // EVALUA SI EL MATERIAL NO YA HA SIDO AGREGADO, EVITA QUE SE REPITA DICHO ELEMENTO EN LA LISTA
			   let valObj = this.cotizacion_servicio.ListaEquipoCot.filter(function(elem) {
                    if(elem.IdEquipoCot === obj.IdEquipoCot) {
                        return elem.IdEquipoCot;
                    }
                });

			   if(valObj.length > 0){
				   return false;
			   }

				blocker = true;

            }

			let lista = {
				IdEquipoCot: IdEquipoCot,
				Nombre: Nombre,
				costoUnitario: Precio,
				cantidad: 1,
				totalIndividual: Precio,
				blocked: blocker,
                Codigo: Codigo,
				Item:Item,
				Unidad:Unidad,
				Stock:Stock,
				Marca:Marca,
				Modelo:Modelo
			};

			this.cotizacion_servicio.ListaEquipoCot.push(lista);
        },
        calcula_importe_equipo(item) {
            let Precio	 	= parseFloat(item.costoUnitario);
            let Cantidad 	= parseFloat(item.cantidad);
			// let FactorDescuento 	= parseFloat(item.FactorDescuento);
            let Resultado  	= (Precio * Cantidad);

            // MARKUP - SE UBICA CON IMPORTE DEL MATERIAL EL RANGO EN EL QUE CALIFICA PARA TENER EL VALOR DE MARKUP
            let valObj = this.Listamarkup.filter(function(elem) {
                if(parseFloat(elem.Monto_I) <= Resultado && parseFloat(elem.Monto_F) >= Resultado) {
					return elem;
                }
            });

            let CostoMarkup = 0;
            if(valObj.length > 0){
				CostoMarkup = parseFloat(valObj[0].CostoM);
            }


			if(CostoMarkup === 0){CostoMarkup=0}
            if(Precio === 0){Precio=0}
            if(Cantidad === 0){Cantidad=0}
            if(Resultado === 0){Resultado=0}

            let subTotal = isNaN( (Resultado * CostoMarkup) ) ? 0 : (Resultado * CostoMarkup);

			item.totalIndividual = subTotal.toFixed(2);


           this.calcula_total_equipo();
        },
        calcula_total_equipo(){
			let Total = 0;
			this.cotizacion_servicio.ListaEquipoCot.forEach(element => {
				if(parseFloat(element.totalIndividual) !== 0){
					Total+=parseFloat(element.totalIndividual);
				}
			});

			let subTotal = isNaN(Total) ? 0 : Total;
			this.cotizacion_servicio.TotalEquipos = subTotal.toFixed(2);
            this.CalcularTotalGarantia();
		},
        delete_equipo(index) {
            this.cotizacion_servicio.ListaEquipoCot.splice(index, 1);
			this.calcula_total_equipo();
        },

		//===========================================REFACCION============================================
		add_Refaccion(obj){
            let IdRefaccion	= 0;
            let Descripcion	= '';
            let Valor		= 0;
			let blocker = false;
            let Sku = '';
			let Unidad = '';
			let Item = '';
			let Marca = '';
			let Modelo = '';
			let Stock = 0;
			let NumParte = '';

            if(obj !== undefined) {
               IdRefaccion 	= parseInt(obj.IdRefaccion);
               Descripcion 	= obj.Descripcion.trim();
               Valor 		= parseFloat(obj.Valor);
               Sku 	= obj.Sku.trim() != null ? obj.Sku.trim() : '';
			   Item 	= obj.Item!=null ? obj.Item.trim() : '';
			   Marca 	= obj.Marca!=null ? obj.Marca.trim() : '';
			   Modelo 	= obj.Modelo!=null ? obj.Modelo.trim() : '';
			   NumParte 	= obj.NumParte!=null ? obj.NumParte.trim() : '';
			   Unidad 	= obj.Unidad.trim();
			   Stock 		= parseFloat(obj.Stock);

			   // EVALUA SI EL MATERIAL NO YA HA SIDO AGREGADO, EVITA QUE SE REPITA DICHO ELEMENTO EN LA LISTA
			   let valObj = this.cotizacion_servicio.ListaRefaccion.filter(function(elem) {
                    if(elem.IdRefaccion === obj.IdRefaccion) {
                        return elem.IdRefaccion;
                    }
                });

			   if(valObj.length > 0){
				   return false;
			   }

				blocker = true;

            }

			let lista = {
				IdRefaccion: IdRefaccion,
				Descripcion: Descripcion,
				costoUnitario: Valor,
				cantidad: 1,
				totalIndividual: Valor,
				blocked: blocker,
                Sku: Sku,
				Item:Item,
				Unidad:Unidad,
				Stock:Stock,
				Marca:Marca,
				Modelo:Modelo,
				NumParte:NumParte
			};

			this.cotizacion_servicio.ListaRefaccion.push(lista);
        },
		calcula_importe_refaccion(item) {
            let Precio	 	= parseFloat(item.costoUnitario);
            let Cantidad 	= parseFloat(item.cantidad);
			// let FactorDescuento 	= parseFloat(item.FactorDescuento);
            let Resultado  	= (Precio * Cantidad);

            // MARKUP - SE UBICA CON IMPORTE DEL MATERIAL EL RANGO EN EL QUE CALIFICA PARA TENER EL VALOR DE MARKUP
            let valObj = this.Listamarkup.filter(function(elem) {
                if(parseFloat(elem.Monto_I) <= Resultado && parseFloat(elem.Monto_F) >= Resultado) {
					return elem;
                }
            });

            let CostoMarkup = 0;
            if(valObj.length > 0){
				CostoMarkup = parseFloat(valObj[0].CostoM);
            }


			if(CostoMarkup === 0){CostoMarkup=0}
            if(Precio === 0){Precio=0}
            if(Cantidad === 0){Cantidad=0}
            if(Resultado === 0){Resultado=0}

            let subTotal = isNaN( (Resultado * CostoMarkup) ) ? 0 : (Resultado * CostoMarkup);
			// let subTotal = Resultado
			item.totalIndividual = subTotal.toFixed(2);


           this.calcula_total_refaccion();
        },
		calcula_total_refaccion(){
			let Total = 0;
			this.cotizacion_servicio.ListaRefaccion.forEach(element => {
				if(parseFloat(element.totalIndividual) !== 0){
					Total+=parseFloat(element.totalIndividual);
				}
			});

			let subTotal = isNaN(Total) ? 0 : Total;
			this.cotizacion_servicio.TotalRefacciones = subTotal.toFixed(2);
			this.calcula_total_material();
			this.CalcularTotalGarantia();
		},
		delete_refaccion(index) {
            this.cotizacion_servicio.ListaRefaccion.splice(index, 1);
			this.calcula_total_refaccion();
        },



        // ========================================= CONTRATISTA =========================================

        add_Contratistas(obj){
            let IdContratista=0;
			let Item='';
			let Unidad='Hora';
            let Nombre	= '';
            let Precio		= 0;
            let Burden=0;
			let Proveedor	= '';
			let blocker = false;

            if (obj!==undefined) {
                IdContratista=parseInt(obj.IdContratista);
                Nombre=obj.Nombre;
				Proveedor=obj.Proveedor;
                Precio=parseFloat(obj.Precio);
                Item=obj.Item;
				Unidad=obj.Unidad == '' ? 'Hora' : obj.Unidad;
                let valObj = this.cotizacion_servicio.ListaContratista.filter(function(elem) {
                    if(elem.IdContratista === obj.IdContratista) {
                        return elem.IdContratista;
                    }
                });

			   if(valObj.length > 0){
				   return false;
			   }

				blocker = true;
            }

            let lista = {
				IdContratista: IdContratista,
				Nombre: Nombre,
				CostoUnitario: Precio,
				Cantidad: 1,
				TotalIndividual: Precio,
                Burden:Burden,
				Item:Item,
				Unidad:Unidad,
				blocked: blocker,
				Proveedor:Proveedor
			};

			this.cotizacion_servicio.ListaContratista.push(lista);
        },
        calcula_importe_contratista(item) {
            let Precio	 	= parseFloat(item.CostoUnitario);
            let Cantidad 	= parseFloat(item.Cantidad);
			let Burden=item.Unidad=="Hora" ? this.cotizacion_servicio.ListaManoObra[0].Burden : this.cotizacion_servicio.ListaManoObra[0].BurdenDia;
            let Resultado  	= (Precio * Cantidad);

            item.TotalIndividual = Resultado.toFixed(2);
			// console.log(item.Unidad=='Dia');
            if (this.InicioCalculo==0) {
                setTimeout(() => {
					if (item.Unidad=='Dia') {
						item.Burden=(((item.TotalIndividual/this.cotizacion_servicio.ListaManoObra[0].CostoDia)/4)*Burden).toFixed(2);
					}
					else{
						item.Burden=(((item.TotalIndividual/this.cotizacion_servicio.ListaManoObra[0].CostoHora)/4)*Burden).toFixed(2);
					}
                    this.InicioCalculo++;
                }, 750);
            }
            else{
				if (item.Unidad=='Dia') {
					item.Burden=(((item.TotalIndividual/this.cotizacion_servicio.ListaManoObra[0].CostoDia)/4)*Burden).toFixed(2);	
				}
				else{
					item.Burden=(((item.TotalIndividual/this.cotizacion_servicio.ListaManoObra[0].CostoHora)/4)*Burden).toFixed(2);
				}
            }
			// console.log(item.Burden)

           this.calcula_total_contratista();
        },
        calcula_total_contratista(){
            let Total = 0;
			this.cotizacion_servicio.ListaContratista.forEach(element => {
				if(parseFloat(element.TotalIndividual) !== 0){
					Total+=parseFloat(element.TotalIndividual);
				}
			});

			let subTotal = isNaN(Total) ? 0 : Total;
			this.cotizacion_servicio.TotalContratistas = subTotal.toFixed(2);
            this.CalcularTotalCostoBurden();
            // this.CalcularTotalGarantia();
        },
        delete_contratista(index) {
            this.cotizacion_servicio.ListaContratista.splice(index, 1);
			this.calcula_total_contratista();
        },

        // ========================================= VIATICO =========================================

        add_Viaticos(obj){
            let IdViatico=0;
            let Nombre	= '';
			let Item='';
			let Unidad='';
            let Precio		= 0;
			let blocker = false;

            if (obj!==undefined) {
                IdViatico=parseInt(obj.IdViatico);
                Nombre=obj.Nombre;
				Unidad=obj.Unidad;
                Precio=parseFloat(obj.Precio);
				Item=obj.Item;
                
                let valObj = this.cotizacion_servicio.ListaViatico.filter(function(elem) {
                    if(elem.IdViatico === obj.IdViatico) {
                        return elem.IdViatico;
                    }
                });

			   if(valObj.length > 0){
				   return false;
			   }

				blocker = true;
            }

            let lista = {
				IdViatico: IdViatico,
				Nombre: Nombre,
				Unidad: Unidad,
				CostoUnitario: Precio,
				Item:Item,
				Cantidad: 1,
				TotalIndividual: Precio,
				blocked: blocker,
			};

			this.cotizacion_servicio.ListaViatico.push(lista);
        },
        calcula_importe_viatico(item) {
            let Precio	 	= parseFloat(item.CostoUnitario);
            let Cantidad 	= parseFloat(item.Cantidad);
            let Resultado  	= (Precio * Cantidad);

			item.TotalIndividual = Resultado.toFixed(2);


           this.calcula_total_viatico();
        },
        calcula_total_viatico(){
            let Total = 0;
			this.cotizacion_servicio.ListaViatico.forEach(element => {
				if(parseFloat(element.TotalIndividual) !== 0){
					Total+=parseFloat(element.TotalIndividual);
				}
			});

			let subTotal = isNaN(Total) ? 0 : Total;
			this.cotizacion_servicio.TotalViaticos = subTotal.toFixed(2);
            this.CalcularTotalGarantia();
        },
        delete_viatico(index) {
            this.cotizacion_servicio.ListaViatico.splice(index, 1);
			this.calcula_total_viatico();
        },

        // ========================================= RESULTADO =========================================
        CalcularTotalCostoDesplazamiento(){
            // if (this.ContLoader==0) {
            //     this.pConfigLoad.ShowLoader=true;
            // } 
            var Distancia=this.cotizacion_servicio.Distancia;
            var CostoKM=this.cotizacion_servicio.CostoKm; 
            var Valor=0;
            if(Distancia==''){Distancia=0;}
            if(CostoKM==''){CostoKM=0;}
          
            Valor = (parseFloat(Distancia)*2)*parseFloat(CostoKM);
			let SumaDias=0;
			// console.log(this.cotizacion_servicio.ListaManoObra);
			this.cotizacion_servicio.ListaManoObra.forEach((value) => {
				if (value.Unidad=='Dia') {
					if (value.HoraNormal>0) {
						SumaDias+=value.HoraNormal;	
					}
				}
				else{
					if (value.Categoria!='' && (value.HoraNormal!='' && value.HoraNormal!=0)) {
						SumaDias+=1;	
					}
				}
			})
			if (SumaDias<=1) {
				SumaDias=1;
			}
			Valor=Valor*SumaDias;
            this.cotizacion_servicio.TotalCostoKm=parseFloat(Valor.toFixed(0));
            this.CalcularTotalGarantia();

        },
        CalcularTotalMODesplazamiento(){
            let Total=0;
            this.cotizacion_servicio.ListaManoObra.forEach(element => {
                if(element.TotalIndividual!=''){
                    Total+=parseFloat(element.TotalIndividual);
                }
            });

            this.cotizacion_servicio.TotalManoDeObra= Total.toFixed(2); 
            let Distancia=parseFloat(this.cotizacion_servicio.Distancia);
            let Velocidad=parseFloat(this.cotizacion_servicio.Velocidad);
            let total=0;
            this.cotizacion_servicio.ListaManoObra.forEach(element => {
                if((element.HoraNormal!='' && element.HoraNormal>0) || (element.HoraExtra!='' && element.HoraExtra>0)){
                    let TotalInd=((Distancia*2)/Velocidad)*parseFloat(element.CostoMO);
                    if (isNaN(TotalInd) || TotalInd==Infinity) {
                        TotalInd=0;
                    }
                    total+= TotalInd;
                }
            });

            this.cotizacion_servicio.CostoManoObraD=parseFloat(total.toFixed(0));
            this.cotizacion_servicio.TotalManoDeObra=parseFloat(this.cotizacion_servicio.TotalManoDeObra)+this.cotizacion_servicio.CostoManoObraD;
            this.CalcularTotalGarantia();
        },
        CalcularTotalCostoBurden(){
            var total=0;
            var cont=0;
			//DISTANCIA
			var Distancia=(this.cotizacion_servicio.Distancia*2)/this.cotizacion_servicio.Velocidad;
			if (isNaN(Distancia)) {
				Distancia=0;
			}
			// console.log(Distancia);
            this.cotizacion_servicio.ListaManoObra.forEach(element => {
                if (cont<2 || cont>=3)
                {
                    var HoraNorma=0;
                    var HoraExtra=0;
                    var Burden=0;
					var ResDistancia=0;
					var TotalBurden=0;
					// var BurdenDia=0;
					
                    if(element.HoraNormal!='' && element.HoraNormal>0){
                        HoraNorma=element.HoraNormal;
                    }
                    if(element.HoraExtra!='' && element.HoraExtra>0){
                        HoraExtra=element.HoraExtra;
                    }

					if (element.Unidad=='Hora' || element.Unidad=='') {
						if(element.Burden!='' && element.Burden>0){
                        	Burden=element.Burden;
                    	}	
					}
					else{
						if(element.BurdenDia!='' && element.BurdenDia>0){
                        	Burden=element.BurdenDia;
                    	}
					}
					ResDistancia=parseFloat(Distancia)*parseFloat(Burden);
					if (isNaN(ResDistancia)) {
						ResDistancia=0;
					}
                    TotalBurden=parseFloat(HoraNorma + HoraExtra) * parseFloat(Burden);
					if (element.HoraNormal!='' && element.HoraNormal>0) {
						total+=TotalBurden+ResDistancia;
					}
					// console.log(total);
                }
				cont ++; 
            });
            this.cotizacion_servicio.ListaContratista.forEach((element)=>{
                var Burden=0;
                if (element.Burden!='' && element.Burden>0) {
                    Burden=element.Burden;
                }
                total+=parseFloat(Burden);
            })
           this.cotizacion_servicio.CostoBurden=parseFloat(total.toFixed(0));
           this.CalcularTotalGarantia();
        },
        CalcularTotalGarantia(){
            //Garantía = (Materiales + mano de obra + costo desplazamiento + costo mano de obra desplazamiento
            // + micelaneos + costo burden )*  (garantía/100)
			// this.cotizacion_servicio.TotalMateriales+=this.cotizacion_servicio.TotalRefacciones 
            var Materiales=this.cotizacion_servicio.TotalMateriales;
            var Equipos=this.cotizacion_servicio.TotalEquipos;
			// var Refacciones=this.cotizacion_servicio.TotalRefacciones;
            var Contratistas=this.cotizacion_servicio.TotalContratistas;
            var Viaticos=this.cotizacion_servicio.TotalViaticos;
            var TotalManoDeObra=this.cotizacion_servicio.TotalManoDeObra;
            var CostoDesplazamiento=this.cotizacion_servicio.TotalCostoKm;
            // var CostoManoObraD=this.cotizacion_servicio.CostoManoObraD;
            // var TotalMiscelaneo=this.cotizacion_servicio.totalMiscelaneos;
            var CostoBurden=this.cotizacion_servicio.CostoBurden;
            var Garantia=this.cotizacion_servicio.Garantia;

            if(Materiales==''){Materiales=0;}
            if(Equipos==''){Equipos=0;}
			// if(Refacciones==''){Refacciones=0;}
            if(Contratistas==''){Contratistas=0;}
            if(Viaticos==''){Viaticos=0;}
            if(TotalManoDeObra==''){TotalManoDeObra=0;}
            if(CostoDesplazamiento==''){CostoDesplazamiento=0;}
            // if(CostoManoObraD==''){CostoManoObraD=0;}
            // if(TotalMiscelaneo==''){TotalMiscelaneo=0;}
            if(CostoBurden==''){CostoBurden=0;}
            if(Garantia==''){Garantia=0;}
            
            let Total = (parseFloat(Materiales) + parseFloat(Equipos) + parseFloat(Contratistas) + parseFloat(Viaticos) + parseFloat(TotalManoDeObra) + parseFloat(CostoDesplazamiento) + parseFloat(CostoBurden) )*  (parseFloat(Garantia)/100);
            // parseFloat(TotalMiscelaneo) + parseFloat(CostoManoObraD) +
            this.TotalGarantia=Total.toFixed(0);
            //return Total.toFixed(0);
            this.CalcularCostoTotal();
        },
        CalcularCostoTotal(){
            //Costo total = (Materiales + mano de obra + costo desplazamiento + costo mano de obra desplazamiento + micelaneos + costo burden + Garantía)
            var Materiales=this.cotizacion_servicio.TotalMateriales;
			// var Refacciones=this.cotizacion_servicio.TotalRefacciones;
            var Equipos=this.cotizacion_servicio.TotalEquipos;
            var Contratistas=this.cotizacion_servicio.TotalContratistas;
            var Viaticos=this.cotizacion_servicio.TotalViaticos;
            var TotalManoDeObra=this.cotizacion_servicio.TotalManoDeObra;
            var CostoDesplazamiento=this.cotizacion_servicio.TotalCostoKm;
            // var CostoManoObraD=this.cotizacion_servicio.CostoManoObraD;
            // var TotalMiscelaneo=this.cotizacion_servicio.totalMiscelaneos;
            var CostoBurden=this.cotizacion_servicio.CostoBurden;
            var Garantia=this.cotizacion_servicio.Garantia;

            if(Materiales==''){Materiales=0;}
			// if(Refacciones==''){Refacciones=0;}
            if(Equipos==''){Equipos=0;}
            if(Contratistas==''){Contratistas=0;}
            if(Viaticos==''){Viaticos=0;}
            if(TotalManoDeObra==''){TotalManoDeObra=0;}
            if(CostoDesplazamiento==''){CostoDesplazamiento=0;}
            // if(CostoManoObraD==''){CostoManoObraD=0;}
            // if(TotalMiscelaneo==''){TotalMiscelaneo=0;}
            if(CostoBurden==''){CostoBurden=0;}
            if(Garantia==''){Garantia=0;}
            
            let Total=(parseFloat(Materiales) +parseFloat(Equipos)+parseFloat(Contratistas)+parseFloat(Viaticos)+parseFloat(TotalManoDeObra)+parseFloat(CostoDesplazamiento)+parseFloat(CostoBurden)+parseFloat(this.TotalGarantia));
            // +parseFloat(TotalMiscelaneo)+parseFloat(CostoManoObraD)+

            this.cotizacion_servicio.TotalGlobal=parseFloat(Total.toFixed(0));
            this.CalcularTotalValorVenta();
           // return Total.toFixed(0);
        },
        CalcularTotalValorVenta(){
            //COSTOTOTA*100 /GASTOS OPERACIONES;
            let CotosTotal=this.cotizacion_servicio.TotalGlobal;
            let gastoOperaciones=this.cotizacion_servicio.GastoOperaciones;
            if(CotosTotal==''){CotosTotal=0;}
            if(gastoOperaciones==''){gastoOperaciones=0;}
            let Total=parseFloat(CotosTotal)*100/parseFloat(gastoOperaciones);

            if(isNaN(Total) || Total==Infinity){
                Total=0;
            }

            this.cotizacion_servicio.ValorVenta=parseFloat(Total.toFixed(0));
            // if (this.ContLoader==0) {
            //     this.pConfigLoad.ShowLoader=false;
            //     this.ContLoader++;
            // }
            //return Total.toFixed(0);
        },
		Volver(){
			this.$router.push({name:'cotizacion_list'});
		},
		async ListActivos(){
			await this.$http.get('equipos/get',{
				params:{
					Todos:true,
					IdClienteS:this.Ocliente.IdClienteS
				}
			}).then((res)=>{
				this.Equipos=res.data.data.equipos.map((Element) => {
					let Tag='';
					if (Element.CodigoActivo!=null) {
						Tag=Element.CodigoActivo+' - '+Element.Nequipo
					}
					else{
						Tag=Element.Nequipo
					}
					return{
						id:Element.IdEquipo,
						label:Tag
					}
				})
				this.EquiposCopia=res.data.data.equipos.map((Element) => {
					let Tag='';
					if (Element.CodigoActivo!=null) {
						Tag=Element.CodigoActivo+' - '+Element.Nequipo
					}
					else{
						Tag=Element.Nequipo
					}
					return{
						id:Element.IdEquipo,
						label:Tag
					}
				})
			})
		},
		BusquedaEquipo(){
			this.Equipos=this.$LikeSearch(val,this.EquiposCopia);
		}

    },
    created() {
		let Usuario=JSON.parse(sessionStorage.getItem("user"));
		this.IdUsuario=Usuario.IdUsuario;
		this.GetExistVendedor();
        this.get_ListaMarkup();
        this.ListarCostoKm();
        this.bus.$off('SaveCotizacion');
        this.bus.$off('Nuevo');
        this.bus.$off('SeleccionarCliente');

        this.bus.$on('SaveCotizacion',(Propuesta)=> {
			this.cotizacion_servicio.ObjPropuesta=Propuesta;
			// this.cotizacion_servicio.NombreArchivo=Propuesta.NombreArchivo;
			// this.cotizacion_servicio.NombreArchivoFile=Propuesta.NombreArchivoFile;
           	this.Guardar();
        });

        let id=0;
        if(this.Id!=undefined){
            sessionStorage.setItem('IdSaved',JSON.stringify(this.Id));
        }
        id=JSON.parse( sessionStorage.getItem('IdSaved'));

        this.cotizacion_servicio.IdCotizacionServicio=id;
        this.get_list_mo();
        if(id>0){
            this.cotizacion_servicio.IdCotizacionServicio=id;
            this.ConfigLoad.ShowLoader=true;
            // this.Get_Recovery();
            this.isOverlay = true;

        }else{
            this.ShowComponents=true;
            this.isOverlay = false;
        }

        this.bus.$on('SeleccionarCliente',(oSucursal,oCliente)=>
        {
           this.add_datos(oSucursal,oCliente);
           this.CalcularCostoKM();
        });
        
        this.bus.$off('Add_Materiales');
        this.bus.$on('Add_Materiales',(obj)=> {
            this.add_Materiales(obj);
        });

        this.bus.$off('Add_Equipos');
        this.bus.$on('Add_Equipos',(obj)=> {
            this.add_Equipos(obj);
        });

		this.bus.$off('Add_Refacciones');
        this.bus.$on('Add_Refacciones',(obj)=> {
            this.add_Refaccion(obj);
        });



        if(this.objsucursal!=undefined){
            this.add_datos2(this.objsucursal);
        }
    },
}
</script>

<style>

</style>
